import React from 'react';
import { ProductPageModel } from '../../Types/ProductPageModel';

const ProductPageStructuredData = ({
  productPage,
}: {
  productPage: ProductPageModel;
}) => {
  const product = productPage.productItem;
  const price = product.price;
  return (
    <>
      {/* MPN would be the id that is commonly used by everyone for this item */}
      <meta itemProp="mpn" content={product.id} />
      {/* SKU could be the internal variant id in Litium */}
      <meta itemProp="sku" content={product.id} />
      <meta itemProp="name" content={product.name} />
      <meta itemProp="description" content={product.description} />
      {product.images?.map((img, idx) => (
        <link
          itemProp="image"
          href={img.originalSrc}
          key={`${product.id}-meta-image-${idx}`}
        />
      ))}
      {product.brand && (
        <div
          itemProp="brand"
          itemType="https://schema.org/Brand"
          itemScope
        >
          <meta itemProp="name" content={product.brand} />
        </div>
      )}
      {price && (
        <div
          itemProp="offers"
          itemType="https://schema.org/Offer"
          itemScope
        >
          <meta
            itemProp="price"
            content={
              price.campaignPrice?.priceWithVat?.toString() ??
              price.price?.priceWithVat?.toString()
            }
          />
          <meta itemProp="priceCurrency" content={price.currency.id} />
        </div>
      )}
    </>
  );
};

export default ProductPageStructuredData;
